import { Box, Button, Container, Stack, Typography } from '@mui/material';
import React, { useEffect } from 'react';

import CheckIcon from '@mui/icons-material/Check';
import DiscountBanner from './landingPage/discountBanner';
import FooterSection from './footerSection';
import Navbar from 'src/components/navbar/navbar';
import TypingEffect from 'src/components/typingEffect';
import backgroundImage from "../resources/images/hero_img_bg.jpg";
import bannerBgImage from "../resources/images/img_3.jpg";
import { content } from 'src/common/lang/en-US';
import img1 from "../resources/images/img_1.jpg";
import img3 from "../resources/images/img_3.jpg";
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const QualificationSection: React.FC = () => (
  <Box
    sx={{
      pt: 14,
      pb: 10,
      px: 2,
      backgroundColor: '#fafafa',
      position: 'relative',
      zIndex: 2,
    }}
  >
    <Container maxWidth="lg">
      <Typography
        variant="subtitle1"
        color="primary.main"
        textAlign="center"
        mb={1}
        sx={{ letterSpacing: '0.05em' }}
      >
        Our Qualification
      </Typography>
      <Box
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
        }}
        gap={4}
        mt={4}
      >
        {content.aboutPage.qualifications.map((q, idx) => (
          <Box
            key={idx}
            sx={{
              backgroundColor: '#ffffff',
              p: 4,
              borderRadius: 3,
              boxShadow: 2,
              textAlign: 'center',
              transition: 'transform 0.3s ease',
              '&:hover': {
                transform: 'translateY(-5px)',
              },
            }}
          >
            <Box mb={2}><CheckIcon /></Box>
            <Typography variant="h6" fontWeight={600} gutterBottom>
              {q.title}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              mt={1}
              sx={{ lineHeight: 1.6 }}
            >
              {q.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Container>
  </Box>
);
const AboutPage: React.FC = () => {
    const { heading, headingContent, history } = content.aboutPage;

    const { ref: buttonRef, inView: buttonInView } = useInView({ triggerOnce: true, threshold: 0.2 });
    const { ref: aboutRef, inView: aboutInView } = useInView({ triggerOnce: true, threshold: 0.2 });

      useEffect(() => {
        window.scrollTo({ top: 0 })
      }, []);

    return (
        <Box sx={{ position: 'relative', overflowX: 'hidden' }}>
            {/* Hero Section */}
            <Box sx={{ position: 'relative', height: '100vh' }}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        zIndex: 0,
                    }}
                />
                <Box
                    sx={{
                        position: 'relative',
                        zIndex: 1,
                        height: '100%',
                        display: 'flex',
                        flexDirection: "column",
                        alignItems: 'center',
                        color: '#fff',
                        textAlign: 'center',
                        background: 'rgba(0, 0, 0, 0.3)',
                    }}
                >
                    <Navbar />
                    <Container sx={{ mt: 12 }}>
                        <Typography variant="h1_Thin" component="h1" gutterBottom>
                            {heading}{"\u00A0"}
                            <TypingEffect
                                words={headingContent}
                                typographySX={{
                                    color: '#ea728c',
                                    fontSize: '4rem',
                                }}
                                varient="h1_Thin"
                            />
                        </Typography>
                        <Stack ref={buttonRef} justifyContent="center" direction="row" width="100%">
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                animate={buttonInView ? { opacity: 1, y: 0 } : {}}
                                transition={{ duration: 0.8 }}
                            >
                                <Button
                                    sx={{
                                        backgroundColor: '#ea728c',
                                        color: '#FFFFFF',
                                        borderRadius: '30px',
                                        px: '30px',
                                        py: '18px',
                                        mt: 4,
                                        fontSize: '14px',
                                        width: '10rem',
                                    }}
                                >
                                    Get Started
                                </Button>
                            </motion.div>
                        </Stack>
                    </Container>
                </Box>
            </Box>
            
            {/* Qualification Section */}
            <QualificationSection/>

            {/* Content Section */}
            <Box sx={{ pt: 10, backgroundColor: '#fff', zIndex: 2, position: 'relative', pb:4, width: "100%"}}>
                <Box px={10} bgcolor="#fff" width="100%" >
                    <Box
                        display="grid"
                        gap={8}
                        width="100%"
                        gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: 'repeat(2, 1fr)',
                            md: 'repeat(2, 1fr)',
                        }}
                    >
                        <Stack direction="column" gap={2}>
                            <img src={img1} alt="img1" style={{ maxWidth: '100%', height: 'auto', display: 'block', borderRadius: "8px" }} />
                            <img src={img3} alt="img3" style={{ maxWidth: '100%', height: 'auto', display: 'block', borderRadius: "8px" }} />
                        </Stack>

                        <motion.div
                            ref={aboutRef}
                            initial={{ opacity: 0, y: 40 }}
                            animate={aboutInView ? { opacity: 1, y: 0 } : {}}
                            transition={{ duration: 0.9 }}
                        >
                            <Stack direction="column" gap={2} px={{ sx: 2, sm: 6, md: 6, lg: 6, xl: 6 }}>
                                <Typography variant='subtitle1' color='primary.main'>{history.title}</Typography>
                                <Typography variant='h4_Thin'>{history.content}</Typography>
                                {history.subContent.map((subContent, idx) => (
                                    <Typography key={idx} fontWeight={400} variant='h5' color="body.dimGray">{subContent}</Typography>
                                ))}
                                <Stack mt={2} direction="column" gap={2}>
                                    {history.points.map((point, idx) => (
                                        <Stack key={idx} direction="row" gap={2}>
                                            <CheckIcon sx={{ color: "body.bgSoftGreen" }} />
                                            <Typography fontWeight={400} variant='h5' color="body.dimGray">{point}</Typography>
                                        </Stack>
                                    ))}
                                </Stack>
                            </Stack>
                        </motion.div>
                    </Box>

                    {/* Our Staff Section */}
                    {/* <Stack py={20} direction="column" gap={2} width="100%" alignItems="center">
                        <Stack width={{ sx: "100%", sm: "60%", md: "60%", lg: "60%", xl: "60%" }} direction="column" alignItems="center" gap={2}>
                            <Typography variant='subtitle1' color='primary.main'>{ourStaffs.title}</Typography>
                            <Typography variant='h4_Thin'>{ourStaffs.subTitle}</Typography>
                        </Stack>

                        <Box
                            mt={8}
                            px={{ xs: 4, sm: 4, md: 6, lg: 10 }}
                            display="grid"
                            gap={4}
                            width="100%"
                            gridTemplateColumns={{
                                xs: 'repeat(1, 1fr)',
                                sm: 'repeat(2, 1fr)',
                                md: 'repeat(2, 1fr)',
                            }}
                        >
                            {ourStaffsData.map((staff, i) => (
                                <Stack key={i} alignItems="center" direction="column" gap={2}>
                                    <Avatar sx={{ height: "16rem", width: "16rem" }} src={staff.image} />
                                    <Typography variant='subtitle3_Thin'>{staff.name}</Typography>
                                    <Typography variant='h9' color='primary.main'>{staff.role}</Typography>
                                    <Typography variant='h6_Thin'>{staff.about}</Typography>
                                </Stack>
                            ))}
                        </Box>
                    </Stack>*/}
                </Box> 
            </Box>

            {/* Discount Banner */}
            <Box
                sx={{
                    position: 'relative',
                    height: '60vh',
                    backgroundImage: `url(${bannerBgImage})`,
                    backgroundSize: 'cover',
                    backgroundAttachment: 'fixed',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(234, 114, 140, 0.9)',
                        zIndex: 1,
                    }}
                />
                <Box sx={{ position: 'relative', zIndex: 2 }}>
                    <DiscountBanner />
                </Box>
            </Box>

            {/* Footer */}
            <FooterSection />
        </Box>
    );
};

export default AboutPage;
